import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
standalone:true,
  name: 'transformString'
})
export class TransformStringPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return window['utils'].transformString(value)
    }
}
